import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { I18nProvider } from "@/i18n/I18nContext";
import { SmoothScrollProvider } from "@/components/SmoothScroll";
import ScrollToTop from "@/components/ScrollToTop";
import LangLayout from "@/components/LangLayout";
import Home from "@/pages/Home";
import Privacy from "@/pages/Privacy";
import Cookies from "@/pages/Cookies";
import Terms from "@/pages/Terms";
import ThankYou from "@/pages/ThankYou";

function App() {
  return (
    <I18nProvider>
      <BrowserRouter>
        <SmoothScrollProvider>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Navigate to="/ar" replace />} />
            <Route path="/thank_you" element={<ThankYou />} />
            <Route path="/:lang" element={<LangLayout />}>
              <Route index element={<Home />} />
              <Route path="privacy" element={<Privacy />} />
              <Route path="cookies" element={<Cookies />} />
              <Route path="terms" element={<Terms />} />
            </Route>
            <Route path="*" element={<Navigate to="/ar" replace />} />
          </Routes>
        </SmoothScrollProvider>
      </BrowserRouter>
    </I18nProvider>
  );
}

export default App;
